document.querySelectorAll('.product-tabs .tab').forEach(function(tab) {
  tab.addEventListener('click', function(evt) {
    evt.preventDefault();
    tab.classList.toggle('active');
    tab.parentElement.querySelectorAll('.tab').forEach(function(sibling) {
      if (sibling !== tab) {
        sibling.classList.remove('active');
      }
    });
    var sel = tab.getAttribute('data-toggle-target');
    document.querySelectorAll('.product-tabs .tab-content').forEach(function(content) {
      content.classList.remove('active');
      if (content.matches(sel)) {
        content.classList.add('active');
      }
    });
  });
});


document.querySelectorAll('.tabDesc__read-more-btn').forEach(function(button) {
  button.addEventListener('click', function() {
    button.closest('.tabDesc__truncated-desc').style.display = 'none'; // Hide truncated description
    document.querySelector('.tabDesc__full-desc').style.display = 'block'; // Show full description
  });
});

